import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreUsersSelfModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeactivateOrDeleteAccountSharedAlternativesComponent } from './deactivate-or-delete-account-shared-alternatives.component';
import { DeactivateOrDeleteAccountSharedConfirmUsernameComponent } from './deactivate-or-delete-account-shared-confirm-username.component';
import { DeactivateOrDeleteAccountSharedConsequencesComponent } from './deactivate-or-delete-account-shared-consequences.component';
import { DeactivateOrDeleteAccountSharedFormComponent } from './deactivate-or-delete-account-shared-form.component';

@NgModule({
  imports: [CommonModule, DatastoreUsersSelfModule, TrackingModule, UiModule],
  declarations: [
    DeactivateOrDeleteAccountSharedAlternativesComponent,
    DeactivateOrDeleteAccountSharedConfirmUsernameComponent,
    DeactivateOrDeleteAccountSharedConsequencesComponent,
    DeactivateOrDeleteAccountSharedFormComponent,
  ],
  exports: [
    DeactivateOrDeleteAccountSharedAlternativesComponent,
    DeactivateOrDeleteAccountSharedConfirmUsernameComponent,
    DeactivateOrDeleteAccountSharedConsequencesComponent,
    DeactivateOrDeleteAccountSharedFormComponent,
  ],
})
export class DeactivateOrDeleteAccountSharedModule {}
